import React, { forwardRef } from 'react';
import { styled, ButtonBase } from '@mui/material';

const CustomButtonBase = styled(ButtonBase)(({ selected, theme }) => {
    return {
        borderRadius: '6px',
        width: '100%',
        padding: theme.spacing(2),
        background: theme.palette.ensightful.shades[0],
        '&:focus-visible': {
            background: theme.palette.ensightful.primary[100],
            outline: `${theme.palette.ensightful.secondary[100]} solid 3px`,
        },
        '&:hover': {
            background: theme.palette.ensightful.primary[100],
        },
        '&:active': {
            background: theme.palette.ensightful.primary[200],
        },
        '& > *': {
            width: '100%',
        },
        ...(selected && {
            background: theme.palette.ensightful.primary[50],
        }),
    };
});

export default forwardRef(({ selected, ...rest }, ref) => {
    return <CustomButtonBase ref={ref} selected={selected} {...rest} />;
});
